const SLACK_CHANNELS = {
    COMMUNICATIONS_FEEDBACK: window.environment === 'Production' ? 'web-sms-feature-feedback' : 'web-sms-feature-feedback-test',
    IN_APP_FEEDBACK: 'pd-keap-in-app-feedback',
    MAX_CLASSIC_FEEDBACK: 'pro-max-lp-feedback',
    EMAIL_ANALYTICS_FEEDBACK: 'pd-email-analytics-feedback',
    SELENIUM_AUTOMATION_FEEDBACK: 'selenium-automation-feedback',
    MONEY_IN_APP_FEEDBACK: 'money-in-app-feedback'
};

const SLACK_MESSAGE_TYPES = {
    ERROR: '#FF0000',
    SUCCESS: '#32CD32',
};

export {
    SLACK_CHANNELS,
    SLACK_MESSAGE_TYPES,
};
